import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { formatISO } from 'date-fns';
import { DetailedInstaller } from '~gc/domains/models/detailed-installer';
import { Installer, InstallerTeamLead, isInstallerLead, User } from '~gc/domains/users/user/user.model';
import { UsersUIFacade } from '../../../domains/users';
import { selectedInstallerTeamLeadProfile } from '../../../domains/users/users-ui.actions';
import { DetailedWorkOrder } from '../../../domains/work/models/detailed-work-order';
import { WorkOrder } from '../../../domains/work/work-order/work-order.model';

@Component({
  selector: 'gc-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss'],
})
export class UserHeaderComponent {
  @Input() isLoading = false;
  @Input() user?: User | DetailedInstaller;
  @Input() workOrder?: WorkOrder | DetailedWorkOrder;
  @Input() centered = true;

  validInsurance(user: InstallerTeamLead) {
    return user.insuranceExpiration > formatISO(Date.now());
  }

  meetsHammerRatingThreshold(user: DetailedInstaller) {
    return ((user as DetailedInstaller).keyHammerRating ?? 0) >= (this.workOrder?.minimumHammerRatingThreshold ?? 0);
  }

  showInstallerProfile(installer: DetailedInstaller) {
    this.usersUI.showInstallerProfile(installer as Installer);
  }

  showInstallerTeamLeadProfile(installer: DetailedInstaller) {
    this.store.dispatch(selectedInstallerTeamLeadProfile({ installer: installer as InstallerTeamLead }));
  }

  /**
   * TT-238: the rank for a VTI value, in the same bands the backend uses when it
   * scores an installer (VtiRatingService.getRank), so the pill and the Dashboard agree.
   */
  rankFor(value?: number | null): string {
    const score = value ?? 0;
    if (score < 0.25) return 'Rookie';
    if (score < 0.75) return 'Intermediate';
    if (score < 1.5) return 'Experienced';
    if (score < 2.5) return 'Proficient';
    if (score < 3.5) return 'Expert';
    if (score < 4.5) return 'Master';
    if (score < 5.25) return 'Artisan';
    return 'Elite Artisan';
  }

  isDetailedInstaller<T extends User>(user: User): user is DetailedInstaller {
    return isInstallerLead(user) ? typeof (user as DetailedInstaller).keyHammerRating === 'number' : false;
  }

  constructor(
    public usersUI: UsersUIFacade,
    public readonly store: Store,
  ) {}
}
